import InvisibleDotIcon from './InvisibleDotIcon';

export default InvisibleDotIcon;
